import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import { Collapse } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Dropdown from 'react-bootstrap/Dropdown'
import Form from 'react-bootstrap/Form'
import Overlay from 'react-bootstrap/Overlay'
import ButtonToolbar from 'react-bootstrap/ButtonToolbar'
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelectCheckbox from './MultiSelectCheckbox.jsx';
import OutsideClickHandler from 'react-outside-click-handler';
import queryString from 'query-string';
import { appService } from '../../_services';
import { MdClose } from "react-icons/md";
import { MdCancel } from "react-icons/md";
import { Redirect, Route } from 'react-router-dom';
import { MdSearch } from "react-icons/md";
import { MdHelp } from "react-icons/md";
import { IoMdHelp } from "react-icons/io";
import { Button, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import DropdownButton from 'react-bootstrap/DropdownButton';
import SplitButton from 'react-bootstrap/SplitButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

let params = ''
var Authorcount = 0;
var SearchText = '';

var Hometsyle = {
    opacity: '0.9',
    backgroundColor: '#FFFFFF', fontStyle: 'italic',
    boxShadow: '0px 5px 9px 0px #888888'
}
var otherstyle = {
    backgroundColor: '#FFFFFF', fontStyle: 'italic'
}

var SearchBorder = {
    borderBottom: '2px solid #CCCCCC'
}

var Searchborderzero = {
    borderBottom: '0px'
}

var SearchShadow = {
    boxShadow: '0px 5px 9px 0px #888888'
}

var Setbgcolor = {
    backgroundColor: '#F6F6F6',
    borderRight: '2px solid #CCCCCC'
}
var FixHeight = {
    height: '50px'
}

export class Search extends Component {
    searchBar = React.createRef();
    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.setState({
            redirect: false,
            redirectToSearch: false,
            redirectToURLSearch: false,
            selectedAuthorValue: '',
            selectedPublication: '',
            publishDuration: '',
            BooleanValue1: 'AND',
            BooleanValue2: 'AND'
        });

        this.state = {
            EndDate: new Date(),
            StartDate: new Date(),
        };
        this.state = { ShowBlueChip: false, ContentItem: '', PlaceHolder: 'Enter your search term' };
        this.state = { showText: false };
        this.state = { showwordstitle: false };        
        this.state = { showSubscriptiononly: false };
        this.state = { searchtextboxvalue: '' };
        this.state = { ShowCrossButton: false };
        this.state = { showAuthor: false };
        this.state = { checked: false };
        this.state = { Subscriptionchecked: false };
        this.state = { ShowDatePicker: false };
        this.state = { Showpublication: false };
        this.state = { show: false };
        this.state = { contentType: "" };
        this.state = { publicationString: "" };
        this.state = { authorString: "" };
        this.state = { publicationDateString: "" };
        this.state = { publicationStartDate: "" };
        this.state = { publicationEndDate: "" };
        this.state = { showSearchText: false };
        this.state = { authorName: "" };
        this.state = { redirectToSearch: false };
        this.state = { queryParam: "" };
        this.state = {
            //Publicationdata: 
            //    [{
            //        name: 'Belgian Review of Arbitration', value: 'Belgian Review of Arbitration', isChecked: false
            //    },
            //    {
            //        name: 'International Business Laws', value: 'International Business Laws', isChecked: false
            //    },
            //    {
            //        name: 'Asian International Arbitration', value: 'Asian International Arbitration', isChecked: false
            //    }],

            list: [
                { value: "", name: "All content", isChecked: true },
                { value: "Journal", name: "All journals", isChecked: false },
                { value: "Encyclopaedia", name: "All encyclopaedias", isChecked: false },
                { value: "Manual", name: "All manuals", isChecked: false },
                //{ value: "mysubscription", name: "Your subscriptions", isChecked: false },
            ],
            getResult: [],
            Publicationdata: [],
            getSearchText: [],
            items: [],
            PublicationDatelist: [
                { value: "", name: "All time", isChecked: true },
                { value: "30D", name: "Last 30 days", isChecked: false },
                { value: "3M", name: "Last 3 months", isChecked: false },
                { value: "1Y", name: "Last one year", isChecked: false },
                { value: "3Y", name: "Last 3 years", isChecked: false },
                { value: "CPP", name: "Choose precise period", isChecked: false },

            ],
            listPublication: []
        }

        this.unCheckIt = this.unCheckIt.bind(this);
        this.handlecheckChange = this.handlecheckChange.bind(this);
        this.handleSubscriptioncheckChange = this.handleSubscriptioncheckChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.result = this.result.bind(this);
        this.HandleButtonClick = this.HandleButtonClick.bind(this);
        this.RadiohandlecheckChange = this.RadiohandlecheckChange.bind(this);
        this.filterList = this.filterList.bind(this);
        this.HideAuthor = this.HideAuthor.bind(this);
        this.HideSearchText = this.HideSearchText.bind(this);
        this.HideSearchTextAll = this.HideSearchTextAll.bind(this);
        this.RadioPublicationDateChange = this.RadioPublicationDateChange.bind(this);
        this.HideSaarchonClick = this.HideSaarchonClick.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.updateCustomParent = this.updateCustomParent.bind(this);
        this.RemoveBlueChip = this.RemoveBlueChip.bind(this);
        this.ClearSearchBox = this.ClearSearchBox.bind(this);
        this._handleKeyDown = this._handleKeyDown.bind(this);
        this.setPublication = this.setPublication.bind(this);
        this.ChangeBooleanOp1 = this.ChangeBooleanOp1.bind(this);
        this.ChangeBooleanOp2 = this.ChangeBooleanOp2.bind(this);
        //this.GetSearchParamValues = this.GetSearchParamValues(this);
    }

    ChangeBooleanOp1(selVal) {
        var a = selVal.target.value;
        this.setState({ BooleanValue1: selVal.target.value });
    }

    ChangeBooleanOp2(selVal) {
        var a = selVal.target.value;
        this.setState({ BooleanValue2: selVal.target.value });

    }

    RedirectSearch() {
        this.setState({ redirectToSearch: true });
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.SearchTextLostFocus(e);
            this.setState({ showText: false });
            this.updateCustomParent();
            this.setState({ redirect: true });

        }
    }

    ClearSearchBox(event) {
        this.setState({ searchtextboxvalue: '' });

        var updatedList = this.state.Publicationdata;

        this.setState({ items: updatedList });
    }


    HideSaarchonClick(value) {

        var self = this;
        self.setState({
            showText: false
        })
        params = queryString.parse(document.location.search);
        if (value !== "") {

            if (value == "TopicDescription") {
                self.setState({ ShowBlueChip: true, ContentItem: params.name });
                self.setState({ PlaceHolder: 'Enter your search term' })

            }

            else if (value == "JournalPublication") {
                self.setState({
                    ContentItem: decodeURI(document.location.pathname.split('/')[2].replace(/\+/g, ' '))
                    , contentType: "", PlaceHolder: 'Enter your search term'
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));

                self.setState({ ShowBlueChip: true });
            }

            else if (value == "JournalIssue") {

                //appService.getById('Product/GetTitle?id=', params.Productid)
                //    .then(function (data) {
                self.setState({
                    ContentItem: document.location.pathname.split('/')[2].replace(/\+/g, ' ')
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //    });

                self.setState({ ShowBlueChip: true });
            }

            else if (value == "journalarticle") {
                //appService.getById('Product/GetTitle?id=', params.prdid)
                //    .then(function (data) {
                self.setState({
                    ContentItem: document.location.pathname.split('/')[2].replace(/\+/g, ' ')
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //  });

                self.setState({ ShowBlueChip: true });
            }

            else if (value == "Encyclopedias" || value == "encyclopedias") {
                //appService.getById('Product/GetTitle?id=', params.id)
                //    .then(function (data) {
                self.setState({
                    ContentItem: decodeURI(document.location.pathname.split('/')[2].replace(/\+/g, ' '))
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //  });

                self.setState({ ShowBlueChip: true });
            }

            else if (value == "EncyclopediaChapter") {
                //  appService.getById('Product/GetTitle?id=', params.ProductId)
                //   .then(function (data) {
                self.setState({
                    ContentItem: document.location.pathname.split('/')[2].replace(/\+/g, ' ')
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //   });

                self.setState({ ShowBlueChip: true });
            }
            else if (value == "Manuals") {
                //   appService.getById('Product/GetTitle?id=', params.id)
                //      .then(function (data) {
                self.setState({
                    ContentItem: decodeURI(document.location.pathname.split('/')[2].replace(/\+/g, ' '))
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //     });

                self.setState({ ShowBlueChip: true });
            }
            else if (value == "ManualChapter") {
                //appService.getById('Product/GetTitle?id=', params.ProductId)
                //   .then(function (data) {
                self.setState({
                    ContentItem: document.location.pathname.split('/')[2].replace(/\+/g, ' ')
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //    });

                self.setState({ ShowBlueChip: true });
            }

            else if (document.location.pathname.split('/')[1] == "journalarticle" || document.location.pathname.split('/')[1] == "journalIssue") {
                self.setState({
                    ContentItem: document.location.pathname.split('/')[2].replace(/\+/g, ' ')
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //    });
                self.setState({ ShowBlueChip: true });
            }

            else if (document.location.pathname.split('/')[1] == "Encyclopedias" || document.location.pathname.split('/')[1] == "Manuals"
                || document.location.pathname.split('/')[1] == "EncyclopediaChapter" || document.location.pathname.split('/')[1] == "ManualChapter") {
                self.setState({
                    ContentItem: document.location.pathname.split('/')[2].replace(/\+/g, ' ')
                    , contentType: ""
                });
                self.setPublication(document.location.pathname.split('/')[2].replace(/\+/g, ' '));
                //    });
                self.setState({ ShowBlueChip: true });
            }
            else if (value == "SearchResult") {

            }
            else {
                self.unCheckIt();
                self.setState({ showSearchText: false, getSearchText: [] });
                let Searchlist = self.state.list;
                Searchlist.forEach(item => {
                    if (item.name == value) {
                        item.isChecked = true;
                        self.setState({ contentType: item.value });
                    }
                    else {
                        item.isChecked = false;
                    }
                });

                self.setState({ list: Searchlist, ShowBlueChip: true, ContentItem: value });
                //self.setState({ PlaceHolder: 'Search ' + value.toLowerCase() })
            }
        }
        else {
            let Searchlist = self.state.list;
            this.unCheckIt();
            self.setState({ list: Searchlist, ShowBlueChip: false, ContentItem: '' });
            self.setState({ PlaceHolder: 'Enter your search term' });
            self.setState({ showSearchText: false, getSearchText: [], ShowDropdown: false });
            this.ClearSearchBox();
            this.child.current.ClearSearchBox();
            this.child.current.state.ShowDropdown = false;

        }
    }

    setPublication(selVal) {
        let list = this.state.Publicationdata;
        var decodeSelVal = decodeURI(selVal);
        list.forEach(item => {
            if (item.name === decodeSelVal) {
                item.isChecked = true;
                this.state.getResult.push(decodeSelVal);
            }
        });

    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    updateParent = (e) => {

        this.state.publicationString = this.state.getResult.toString();
        if (!this.state.publicationDateString == "CPP") {
            this.state.publicationStartDate = this.formatDate(this.state.StartDate);
            this.state.publicationEndDate = this.formatDate(this.state.EndDate);
        }
        else {
            this.state.publicationStartDate = new Date();
            this.state.publicationEndDate = new Date()
        }

        //alert('contentType :' + this.state.contentType + '\r\n Search word Title : ' + this.state.showwordstitle + '\r\n Publication : ' + this.state.publicationString + '\r\n Author : ' + this.state.authorString + '\r\n Date Range : ' + this.state.publicationDateString + '\r\n Start Date : ' + this.state.publicationStartDate + '\r\n End Date : ' + this.state.publicationEndDate);
        //this.props.menuCallback(e.target.value, this.state.contentType, this.state.showwordstitle, this.state.selectedPublication, this.state.authorString, this.state.publicationDateString, this.state.publicationStartDate, this.state.publicationEndDate);
        this.props.menuCallback(e.target.value, this.state.contentType, this.state.showwordstitle, this.state.publicationString, this.state.selectedAuthorValue, this.state.publishDuration, this.state.publicationStartDate, this.state.publicationEndDate);
    }

    updateCustomParent = (e) => {

        if (typeof e != "undefined") {
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
        }

        this.setState({ showText: false });
        this.state.queryParam = "";

        if (this.state.getSearchText.length == 0) {
            //e.preventDefault();
            // renders <a href="#/calendar/today">
            //{
            //<HashRouter basename="/" />
            ///  <Link to="/SearchResult" />}
        }

        if (typeof this.state.authorString == 'undefined') {
            this.state.authorString = "";
        }
        if (typeof this.state.contentType == 'undefined') {
            this.state.contentType = "";
        }
        this.state.publicationString = this.state.getResult.join("##");
        if (this.state.publicationDateString == "CPP") {
            this.state.publicationStartDate = this.formatDate(this.state.StartDate);
            this.state.publicationEndDate = this.formatDate(this.state.EndDate);
        }
        else {
            this.state.publicationStartDate = new Date();
            this.state.publicationEndDate = new Date();
        }

        var searchVal = "";
        this.state.getSearchText != 'undefined' && this.state.getSearchText != null && this.state.getSearchText.map((item, index) => {
            if (index == 0) {
                if ((item.includes(" AND ") || item.includes(" OR ") || item.includes(" NOT ") || item.includes(" ")) && item.indexOf('"') == -1) {
                    var list = item.split(/( AND )/g).filter(x => x).join('##').split(/( OR )/g).filter(x => x).join('##').split(/( NOT )/g).filter(x => x).join('##').replace(/ AND /g, "#AND#").replace(/ OR /g, "#OR#").replace(/ NOT /g, "#NOT#").split(/( )/g).filter(x => x != "").join('##').replace(/#AND#/g, " AND ").replace(/#OR#/g, " OR ").replace(/#NOT#/g, " NOT ").split('##');
                    var self = this;
                    list.map((word, num) => {
                        if (word != ' AND ' && word != ' OR ' && word != ' NOT ' && word != ' ') {
                            if (num == 0) {
                                searchVal = word;
                            }
                            else {
                                var boolindex = num - 1;
                                searchVal = searchVal + " " + Object.values(self.refs).find(a => a.id == 'SortDropDwn' + index + boolindex).value + " " + word;
                            }
                        }
                    });
                }
                else {
                    searchVal = item;
                }
            }
            else {
                if ((item.includes(" AND ") || item.includes(" OR ") || item.includes(" NOT ") || item.includes(" ")) && item.indexOf('"') == -1) {
                    var list1 = item.split(/( AND )/g).filter(x => x).join('##').split(/( OR )/g).filter(x => x).join('##').split(/( NOT )/g).filter(x => x).join('##').replace(/ AND /g, "#AND#").replace(/ OR /g, "#OR#").replace(/ NOT /g, "#NOT#").split(/( )/g).filter(x => x != "").join('##').replace(/#AND#/g, " AND ").replace(/#OR#/g, " OR ").replace(/#NOT#/g, " NOT ").split('##');
                    var self = this;
                    list1.map((word, num) => {
                        if (word != ' AND ' && word != ' OR ' && word != ' NOT ' && word != ' ') {
                            var boolindex = num - 1;
                            searchVal = searchVal + " " + Object.values(self.refs).find(a => a.id == 'SortDropDwn' + index + boolindex).value + " " + word;
                        }
                    });
                }
                else {
                    searchVal = searchVal + " " + Object.values(this.refs).find(a => a.id == 'SortDropDwn' + index).value + " " + item;
                }
            }

        })
        //var searchDiv = this.refs["Bool"];;

        //const node = ReactDOM.findDOMNode(searchDiv);
        //var ddlnode = node.getElementsByTagName('Dropdown');
        ////var hidep = node.getElementsByClassName('searchresultText');

        //Object.keys(ddlnode).map((item, key) => {
        //    ddlnode[0].selected.value = 1;
        //});

        //if (this.state.getSearchText.length > 2) {
        //    searchVal = this.state.getSearchText[0] + " " + this.state.BooleanValue1 + " " + this.state.getSearchText[1] + " " + this.state.BooleanValue2 + " " + this.state.getSearchText[2];
        //}
        //else if (this.state.getSearchText.length > 1) {
        //    searchVal = this.state.getSearchText[0] + " " + this.state.BooleanValue1 + " " + this.state.getSearchText[1];
        //}
        //else {
        //    searchVal = this.state.getSearchText.toString();
        //}

        //alert('contentType :' + this.state.contentType + '\r\n Search word Title : ' + this.state.showwordstitle + '\r\n Publication : ' + this.state.publicationString + '\r\n Author : ' + this.state.authorString + '\r\n Date Range : ' + this.state.publicationDateString + '\r\n Start Date : ' + this.state.publicationStartDate + '\r\n End Date : ' + this.state.publicationEndDate);
        //this.props.menuCallback(e.target.value, this.state.contentType, this.state.showwordstitle, this.state.selectedPublication, this.state.authorString, this.state.publicationDateString, this.state.publicationStartDate, this.state.publicationEndDate);

        this.props.menuCallback(searchVal, this.state.contentType, this.state.showwordstitle, this.state.publicationString, this.state.authorString, this.state.publicationDateString, this.state.publicationStartDate, this.state.publicationEndDate, this.state.Subscriptionchecked, true);
        //if (searchVal != "") {
        //    this.state.queryParam = "searchText=" + searchVal;
        //}
        //if (this.state.contentType != "") {

        //}

        this.GetSearchParamValues("searchText", searchVal);
        this.GetSearchParamValues("contentType", this.state.contentType);
        this.GetSearchParamValues("showwordstitle", this.state.showwordstitle);
        this.GetSearchParamValues("publication", this.state.publicationString);
        this.GetSearchParamValues("authorString", this.state.authorString);       
        this.GetSearchParamValues("publicationDateString", this.state.publicationDateString);
        this.GetSearchParamValues("Subscriptionchecked", this.state.Subscriptionchecked);
        if (this.state.publicationDateString == "CPP") {
            this.GetSearchParamValues("publicationStartDate", this.state.publicationStartDate);
            this.GetSearchParamValues("publicationEndDate", this.state.publicationEndDate);
        }
        this.setState({ redirectToURLSearch: true });
        //window.location.href = '/SearchContent/query?' + this.state.queryParam;
    }

    GetSearchParamValues(paramName, paramValue) {
        if (paramValue != "") {
            var paramstr = "";
            if (this.state.queryParam) {
                var paramstr = "&" + paramName + "=" + paramValue;
            }
            else {
                var paramstr = paramName + "=" + paramValue;
            }
            this.state.queryParam += paramstr;
        }  
    }

    GenerateSearchText = () => {
        if (this.state.getSearchText.length >= 2) {
            return this.state.getSearchText[0] + " AND " + this.state.getSearchText[1] + " AND " + this.state.getSearchText[2];
        }
        else if (this.state.getSearchText.length >= 1) {
            return this.state.getSearchText[0] + " AND " + this.state.getSearchText[1];
        }
        else {
            return this.state.getSearchText.toString();
        }
    }

    HideAuthor() {
        this.setState({
            showAuthor: !this.state.showAuthor
        });
        this.child.current.clearall()
    }

    SearchTextLostFocus = (e) => {
        SearchText = e.target.value;
        if (e.target.value != "") {
            let text = this.state.getSearchText;
            text.push(e.target.value)
            this.setState({ getSearchText: text });
            this.setState({ showSearchText: true, getInput: '' });
            //if (text.length >= 3) {
            //    e.target.disabled = true;
            //}
            //else {
            //    e.target.disabled = false;
            //}
            //this.updateCustomParent(e);
        }
    }

    HideSearchText(Param) {

        let index = this.state.getSearchText.indexOf(Param);
        if (index > -1) {
            this.state.getSearchText.splice(index, 1);
            this.setState({ getSearchText: this.state.getSearchText });
        };

        //var search = this.searchBar.current;
        //if (search != 'undefined') {
        //    if (this.state.getSearchText.length >= 3) {
        //        search.disabled = true;
        //    }
        //    else if (this.state.getSearchText.length == 2) {
        //        search.disabled = false;
        //        this.state.BooleanValue2 = 'AND';
        //    }
        //    else {
        //        search.disabled = false;
        //        this.state.BooleanValue1 = 'AND';
        //        this.state.BooleanValue2 = 'AND';
        //    }
        //}
        //this.state.getInput == "";        
    }

    HideSearchTextAll(item, Param) {

        //let index = this.state.getSearchText.indexOf(Param);
        let itemindex = this.state.getSearchText.indexOf(item)
        if ((item.includes(" AND ") || item.includes(" OR ") || item.includes(" NOT ") || item.includes(" ")) && item.indexOf('"') == -1) {
            var alllist = item.split(/( AND )/g).filter(x => x).join('##').split(/( OR )/g).filter(x => x).join('##').split(/( NOT )/g).filter(x => x).join('##').replace(/ AND /g, "#AND#").replace(/ OR /g, "#OR#").replace(/ NOT /g, "#NOT#").split(/( )/g).filter(x => x != "").join('##').replace(/#AND#/g, " AND ").replace(/#OR#/g, " OR ").replace(/#NOT#/g, " NOT ").split('##');
            let index = alllist.indexOf(Param);
            if (index > -1) {
                if (index == 0) {
                    alllist.splice(index, 2);
                }
                else {
                    alllist.splice(index - 1, 2);
                }

                var str = alllist.join("");
                this.state.getSearchText[itemindex] = str;
                this.setState({ getSearchText: this.state.getSearchText });
            }
        }
        else {
            let index = this.state.getSearchText.indexOf(Param);
            if (index > -1) {
                this.state.getSearchText.splice(index, 1);
                this.setState({ getSearchText: this.state.getSearchText });
            };
        }

        //var alllist = this.state.getSearchText[0].split(/( AND )/g).join(' # ').split(/( OR )/g).join(' # ').split(/( NOT )/g).join(' # ').split(' # ');
        //let index = alllist.indexOf(Param);
        //if (index > -1) {
        //    alllist.splice(index, 1);
        //    this.setState({ getSearchText: alllist });
        //};

        //var search = this.searchBar.current;
        //if (search != 'undefined') {
        //    if (this.state.getSearchText.length >= 3) {
        //        search.disabled = true;
        //    }
        //    else if (this.state.getSearchText.length == 2) {
        //        search.disabled = false;
        //        this.state.BooleanValue2 = 'AND';
        //    }
        //    else {
        //        search.disabled = false;
        //        this.state.BooleanValue1 = 'AND';
        //        this.state.BooleanValue2 = 'AND';
        //    }
        //}
        //this.state.getInput == "";        
    }


    updateAuthorCount(UpdatedAuthorCount) {
        this.state.authorString = UpdatedAuthorCount.join("##");
        Authorcount = UpdatedAuthorCount.length;
        if (Authorcount !== 0) {
            this.setState({
                showAuthor: true

            });
        }
        else {
            this.setState({
                showAuthor: false

            });
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            authorName: window['SearchAuthor']
        });
        if (typeof this.state.authorName != 'undefined' && window['SearchAuthor'] != "") {
            this.state.authorString = this.state.authorName;
            this.unCheckIt();
            Authorcount = 1;
            if (Authorcount !== 0) {
                this.setState({
                    showAuthor: true

                });
                //this.updateCustomParent();
                //this.setState({ redirectToSearch: true });
            }
        }
    }

    componentWillMount() {
        this.setState({ items: this.state.Publicationdata })

    }

    componentDidMount() {
        var self = this;

        appService.getAll('Product/GetAllPublication')
            .then(function (data) {
                self.setState({ Publicationdata: data });
                self.setState({ items: data });
            });

    }


    filterList(event) {
        var updatedList = this.state.Publicationdata;
        updatedList = updatedList.filter(function (item) {
            return item.name.toLowerCase().search(
                event.target.value.toLowerCase()) !== -1;
        });
        this.setState({ items: updatedList });

        if (event.target.value !== "") {
            this.setState({ ShowCrossButton: true });
            this.setState({ searchtextboxvalue: event.target.value })
        }
        else {
            this.setState({ ShowCrossButton: false })
            this.setState({ searchtextboxvalue: event.target.value })
        }

    }

    gettext = (e) => {
        this.setState({
            getInput: e.target.value,

        });
    }

    getInitialState = () => {
        return { selectValue: 'Author' };
        getInput: this.props.name
    }

    handleStartDateChange(date) {
        this.setState({
            StartDate: date
        });
    }
    handleEndDateChange(date) {
        this.setState({
            EndDate: date
        });
    }

    handleChange = (e) => {
        this.setState({
            selectValue: e.target.value,
            showAuthor: true

        });
    }

    HandleButtonClick = (e) => {
        this.setState({
            ShowDropdown: !this.state.ShowDropdown

        });
    }


    renderList = () => {
        return this.state.items.map(item =>
            <div className="css-1vr111p-option" key={item.name}>
                <div className="square">
                    <input key={item.name} id={"pub_" + item.name} style={{ marginRight: '8px', display: 'inline-block' }} type="checkbox" name={item.name} value={item.name}
                        checked={item.isChecked}
                        onChange={this.result} />
                    <label style={{ fontSize: '13px' }} htmlFor={"pub_" + item.name}>
                    </label>
                    <span style={{ fontSize: '13px' }}>{item.name}</span>
                </div>
            </div>
        )
    }

    result(evt) {
        let list = this.state.Publicationdata;
        list.find(item => item.name === evt.target.name).isChecked = evt.target.checked;
        this.setState({ Publicationdata: list });
        this.state.contentType = "";
        // check if the check box is checked or unchecked
        if (evt.target.checked) {
            // add the numerical value of the checkbox to options array
            let options = this.state.getResult;
            options.push(evt.target.value);
            this.setState({
                getResult: options

            })

        }
        else {
            // or remove the value from the unchecked checkbox from the array
            let index = this.state.getResult.indexOf(evt.target.value);

            if (index > -1) {
                this.state.getResult.splice(index, 1);
                this.setState({ getResult: this.state.getResult });
            };

        }

        this.setState({
            Showpublication: true
        });

        let Hidelist = this.state.list;
        this.state.contentType = "";
        Hidelist.forEach(item => {
            if (item.value != "") {
                item.isChecked = false;
            }
        });

        this.setState({
            ShowBlueChip: false,
        });

    }

    renderPublicationList = () => {

        return this.state.list.map((item, index) =>
            <li key={item.value}>
                <div className="custom-control custom-radio col">
                    <label className="radiocontainer">
                        <input type="checkbox" name={item.name} value={item.value}
                            checked={item.isChecked} onChange={this.RadiohandlecheckChange} />
                        <span className="checkRadiomark">
                        </span>
                    </label>
                    <span className="Searchlabel" style={{ fontSize: '15px' }}>{item.name}</span>
                </div>
            </li>

        )
    }

    RadiohandlecheckChange(evt) {
        if (evt.target.checked === true) {
            let list = this.state.list;
            list.forEach(item => {
                if (item.value === evt.target.value) {
                    item.isChecked = evt.target.checked;
                    this.state.contentType = evt.target.value;
                }
                else {
                    item.isChecked = false;
                }
            });

            if (evt.target.value !== "") {
                this.setState({ list: list, ShowBlueChip: true, ContentItem: evt.target.name });
            }
            else {
                this.setState({ list: list, ShowBlueChip: false });
            }

            // this.setState({ PlaceHolder: 'Search ' + evt.target.name.toLowerCase() });
            let Publicationdata = this.state.Publicationdata;
            Publicationdata.forEach(item => {
                item.isChecked = false;
            });

            this.setState({ Showpublication: false, getResult: [] });

        }

    }

    RenderPublicationDateList = () => {
        return this.state.PublicationDatelist.map(item =>
            <li key={item.value}>
                <div className="custom-control custom-radio col">
                    <label className="radiocontainer">
                        <input type="checkbox" name={item.name} value={item.value}
                            checked={item.isChecked} onChange={this.RadioPublicationDateChange} />
                        <span className="checkRadiomark">
                        </span>
                    </label>
                    <span className="Searchlabel" style={{ fontSize: '15px' }}>{item.name}</span>
                </div>
            </li>

        )

    }

    RadioPublicationDateChange(evt) {
        if (evt.target.checked === true) {
            let list = this.state.PublicationDatelist;
            var IsDateRangeSelected = false;
            list.forEach(item => {
                if (item.value === evt.target.value) {
                    item.isChecked = evt.target.checked;
                    IsDateRangeSelected = true;
                    this.state.publicationDateString = evt.target.value;
                }
                else {
                    item.isChecked = false;
                }
            });

            if (!IsDateRangeSelected) {
                this.state.publicationDateString = "";
            }

            if (evt.target.value === "CPP") {
                this.setState({ ShowDatePicker: true });
            }
            else {
                this.setState({ ShowDatePicker: false });
            }

            this.setState({ PublicationDatelist: list });
        }

    }

    RemoveButton(Param) {
        let index = this.state.getResult.indexOf(Param);
        if (index > -1) {
            this.state.getResult.splice(index, 1);
            this.setState({ getResult: this.state.getResult });
        };

        let list = this.state.Publicationdata;

        list.forEach(item => {
            if (item.name === Param) {
                item.isChecked = false;
            }
        });
    }

    RemoveBlueChip() {

        this.setState({ ShowBlueChip: false, contentType: "" });

        let list = this.state.list;

        list.forEach(item => {

            item.isChecked = false;

        });
        this.setState({ PlaceHolder: 'Enter your search term' });
    }


    unCheckIt() {
        this.setState({
            checked: false,
            showwordstitle: false,
            showAuthor: false,
            selectValue: 'Author',
            ShowDatePicker: false,
            Showpublication: false,
            ShowBlueChip: false,
            contentType: '',
            authorString: '',
            publicationDateString: '',
            showSubscriptiononly: false,
            Subscriptionchecked: false,
            showSearchText: false,
            getSearchText: [],
            getResult: [],
            BooleanValue1: 'AND',
            BooleanValue2: 'AND'

        });
        let Publicationdata = this.state.Publicationdata;
        Publicationdata.forEach(item => {
            item.isChecked = false;
        });

        let list = this.state.list;
        list.forEach(item => {
            if (item.value != "") {
                item.isChecked = false;
            }
        });


        let PublicationDate = this.state.PublicationDatelist;
        PublicationDate.forEach(item => {
            if (item.value != "") {
                item.isChecked = false;
            }
            else {
                item.isChecked = true;
            }
        });

        this.HideAuthor();
        this.setState({ showSearchText: false, getSearchText: [], ShowDropdown: false });
        this.ClearSearchBox();
        this.child.current.ClearSearchBox();
        this.child.current.state.ShowDropdown = false;
    }

    handlecheckChange(evt) {
        if (this.state.checked !== evt.target.checked) {
            this.setState({
                checked: evt.target.checked
            });
        }
        this.setState({ showwordstitle: evt.target.checked });
        //this.updateCustomParent(evt);
    }

    handleSubscriptioncheckChange(evt) {
        if (this.state.Subscriptionchecked !== evt.target.checked) {
            this.setState({
                Subscriptionchecked: evt.target.checked
            });
        }
        this.setState({ showSubscriptiononly: evt.target.checked });
        //this.updateCustomParent(evt);
    }

    handleClick = ({ target }) => {

        this.setState({ show: !this.state.show });

    }

    stingBreakLine(str, length, ending) {

        // str = str.props.dangerouslySetInnerHTML.__html;
        // console.log(str +","+ str.length + "," + length);
        if (length == null) {
            length = 40;
        }
        if (ending == null) {
            ending = '...';
        }
        //console.log(str + "," + length);
        if (str.length > length) {
            //console.log(str.substring(0, length - ending.length));
            return str.substring(0, length - ending.length) + '...';
        } else {
            return str;
        }

    };


    searchTextPill = () => {
        return this.state.getSearchText != 'undefined' && this.state.getSearchText.map((item, index) => {

            if ((item.includes(" AND ") || item.includes(" OR ") || item.includes(" NOT ") || item.includes(" ")) && item.indexOf('"') == -1) {
                //var list = item.split(' ');
                var list = item.split(/( AND )/g).filter(x => x).join('##').split(/( OR )/g).filter(x => x).join('##').split(/( NOT )/g).filter(x => x).join('##').replace(/ AND /g, "#AND#").replace(/ OR /g, "#OR#").replace(/ NOT /g, "#NOT#").split(/( )/g).filter(x => x != "").join('##').replace(/#AND#/g, " AND ").replace(/#OR#/g, " OR ").replace(/#NOT#/g, " NOT ").split('##');

                return <div style={{ display: 'contents' }}>
                    {
                        list.map((word, num) => {

                            if (word == ' AND ') {
                                return (<div className="btn-group" style={{ height: '45px', borderRadius: '4px', margin: '2px' }}>

                                    <select className="dropbtn DropDownArrow OperatorDropdown" ref={"Bool" + index + num} onChange={this.ChangeBooleanOp2} id={"SortDropDwn" + index + num}>
                                        <option selected value="AND">AND</option>
                                        <option value="OR">OR</option>
                                        <option value="NOT">NOT</option>
                                    </select>

                                </div>
                                )
                            }
                            else if (word == ' OR ') {
                                return (<div className="btn-group" style={{ height: '45px', borderRadius: '4px', margin: '2px' }} >

                                    <select className="dropbtn DropDownArrow OperatorDropdown" ref={"Bool" + index + num} onChange={this.ChangeBooleanOp2} id={"SortDropDwn" + index + num}>
                                        <option value="AND">AND</option>
                                        <option selected value="OR">OR</option>
                                        <option value="NOT">NOT</option>
                                    </select>
                                </div>
                                )
                            }
                            else if (word == ' NOT ') {
                                return (<div className="btn-group" style={{ height: '45px', borderRadius: '4px', margin: '2px' }}>
                                    <select className="dropbtn DropDownArrow OperatorDropdown" ref={"Bool" + index + num} onChange={this.ChangeBooleanOp2} id={"SortDropDwn" + index + num}>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                        <option selected value="NOT">NOT</option>
                                    </select>
                                </div>
                                )
                            }
                            else if (word == ' ') {
                                return (
                                    <div className="btn-group" style={{ height: '45px', borderRadius: '4px', margin: '2px' }}>
                                        <select className="dropbtn DropDownArrow OperatorDropdown" ref={"Bool" + index + num} onChange={this.ChangeBooleanOp2} id={"SortDropDwn" + index + num}>
                                            <option selected value="AND">AND</option>
                                            <option value="OR">OR</option>
                                            <option value="NOT">NOT</option>
                                        </select>
                                    </div>
                                )
                            }
                            else {
                                return (<div className="btn-group" style={{ border: "1px solid #85bc20", height: '45px', borderRadius: '4px', margin: '2px' }}>

                                    <div style={{ padding: "10px", borderRadius: "10px 0 0 10px", borderRight: '1px solid #85bc20', backgroundColor: '#FFFF', display: 'inline-block', width: 'max-content' }}>
                                        {word}</div>
                                    <button aria-label="Close" type="button" style={{ padding: '5px', borderRadius: '0px 10px 10px 0px', background: "#FFFF", color: '#85bc20', border: '1px solid #fff', borderLeft: '0' }}
                                        onClick={this.HideSearchTextAll.bind(this, item, word)}>
                                        <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>

                                </div>


                                )
                            }
                        })
                    }

                </div>

            }
            else {

                if (index == 0) {
                    return (<div className="btn-group" style={{ border: "1px solid #85bc20", height: '45px', borderRadius: '4px', margin: '2px' }}>

                        <div style={{ padding: "10px", borderRadius: "10px 0 0 10px", borderRight: '1px solid #85bc20', backgroundColor: '#FFFF', display: 'inline-block', width: 'max-content' }}>
                            {item}</div>
                        <button aria-label="Close" type="button" style={{ padding: '5px', borderRadius: '0px 10px 10px 0px', background: "#FFFF", color: '#85bc20', border: '1px solid #fff', borderLeft: '0' }}
                            onClick={this.HideSearchText.bind(this, item)}>
                            <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>

                    </div>
                    )
                }
                else if (index > 0) {
                    return (<div className="Flexclass">
                        <div className="btn-group" style={{ height: '45px', borderRadius: '4px', margin: '2px' }}>
                            <select className="dropbtn DropDownArrow OperatorDropdown" ref={"Bool" + index} onChange={this.ChangeBooleanOp2} id={"SortDropDwn" + index}>
                                <option selected value="AND">AND</option>
                                <option value="OR">OR</option>
                                <option value="NOT">NOT</option>
                            </select>

                        </div>
                        <div className="btn-group" style={{ border: "1px solid #85bc20", height: '45px', borderRadius: '4px', margin: '2px' }}>
                            <div style={{ padding: "10px", borderRadius: "10px 0 0 10px", borderRight: '1px solid #85bc20', backgroundColor: '#FFFF', display: 'inline-block', width: 'max-content' }}>
                                {item}</div>
                            <button aria-label="Close" type="button" style={{ padding: '5px', borderRadius: '0px 10px 10px 0px', background: "#FFFF", color: '#85bc20', border: '1px solid #fff', borderLeft: '0' }}
                                onClick={this.HideSearchText.bind(this, item)}>
                                <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>
                        </div>
                    </div>

                    )
                }

            }

        })

    }

    render() {
        if (this.state.redirectToSearch) {
            this.setState({ redirectToSearch: false });
            return <Redirect to={"/SearchContent?auth=" + this.state.authorName} />
        }
        if (this.state.redirectToURLSearch) {
            this.setState({ redirectToURLSearch: false });
            return <Redirect to={"/SearchContent/query=?" + this.state.queryParam} />
        }

        if (this.state.redirect) {
            this.setState({ redirect: false });
            return <Redirect to={"/SearchContent/query=?" + this.state.queryParam} />;
        }

        return (

            <div className="input-group customInput">
                <div className="input-group-btn" style={this.state.showText ? FixHeight : null}>
                    <span style={document.location.pathname === "/" ? SearchShadow : null} className="HeightForSearch">
                        <button className="btn dropdown-toggle btnSearch" data-toggle="dropdown" onClick={() => this.setState({ showText: !this.state.showText })}
                            style={!this.state.showText ? SearchBorder : Setbgcolor}>
                            <strong className="leftLabel" >Search filters</strong>
                            {!this.state.showText ?
                                <i className="fa fa-caret-down caret float-none">
                                </i>
                                :
                                <i className="fa fa-caret-up caret float-none">
                                </i>
                            }
                        </button>
                    </span>
                    <Collapse in={this.state.showText}>
                        <ul className="dropdown-menu Searchdropdown">
                            <div className="col-lg-12 BGGrey searchMenuHeight">
                                <div className="row" style={{ marginTop: '7px', marginBottom: '14px', paddingLeft: '15px' }}>
                                   

                                    <div className="col-lg-10">
                                        <div style={{ paddingLeft: '1%', paddingTop: '1%' }}>
                                            <Link to="/CitationSearch" className="LinkClass">Citation search</Link>
                                        </div>
                                        <br></br>


                                        <div className="col-lg-7" >
                                            <div className="col-lg-7 square" style={{ display: 'inline-block' }}>
                                                <input type="checkbox" id="Sqrecheckbox"
                                                    onClick={() => this.setState({ showSubscriptiononly: !this.state.showSubscriptiononly, Subscriptionchecked: true })}
                                                    checked={this.state.Subscriptionchecked || false} onChange={this.handleSubscriptioncheckChange} />
                                                <label htmlFor="Sqrecheckbox"></label><span className="SearchTitlelabel" style={{ fontSize: '15px', paddingLeft: '15px' }}>
                                                    Subscribed publication(s) only </span>
                                            </div>

                                            <div className="col-lg-5 square" style={{ display: 'inline-block' }}>
                                                <input type="checkbox" id="wordstitle"
                                                    onClick={() => this.setState({ showwordstitle: !this.state.showwordstitle, checked: true })}
                                                    checked={this.state.checked || false} onChange={this.handlecheckChange} />
                                                <label htmlFor="wordstitle"></label><span className="SearchTitlelabel" style={{ fontSize: '15px', paddingLeft: '15px' }}>
                                                    Words in title only</span>
                                            </div>

                                        </div>                                        

                                    </div>

                                        
                                    
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">

                                        <hr className="SearchmenuHR"></hr>
                                        <br />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingLeft: '15px' }}>
                                    <div className="col-lg-3 mediasetmargin">
                                        <p>Choose a content type</p>
                                        {this.renderPublicationList()}
                                    </div>
                                    <div className="col-lg-3 mediasetmargin">
                                        <p >Choose publication(s)</p>
                                        <button type="button" className="css-1r4vtzz" onClick={this.HandleButtonClick} style={!this.state.ShowDropdown ? null : Searchborderzero}>
                                            <span className="css-1v99tuv" style={{ verticalAlign: 'middle' }}>Publication</span>
                                            <span className="css-1gpjby2" style={{ float: 'right' }}>
                                                {(this.state.ShowDropdown == true) ?
                                                    <i className="fa fa-caret-up caret float-none" style={{ marginLeft: '1px' }}>
                                                    </i>
                                                    :
                                                    <i className="fa fa-caret-down caret float-none" style={{ marginLeft: '1px' }}>
                                                    </i>
                                                }
                                            </span>
                                        </button>
                                        <Collapse in={this.state.ShowDropdown}>

                                            <div className="css-1pcexqc-container">
                                                <div className="css-1jllj6i-control">
                                                    <input style={{
                                                        fontSize: '14px',
                                                        minHeight: '30px', outline: '0', backgroundColor: '#FFFFFF', border: 'none', color: '#474747', textIndent: '8px'
                                                    }}
                                                        value={this.state.searchtextboxvalue}
                                                        type="text"
                                                        placeholder="Enter publication"
                                                        title="Type the publication that you want to use as filter"
                                                        autoComplete="off"
                                                        onChange={this.filterList.bind(this)}
                                                    />
                                                    {(this.state.ShowCrossButton == true) ?
                                                        <div className="css-1wy0on6">
                                                            <div style={{ color: 'rgb(204, 204, 204)', height: '30px', width: '25px', fontSize: '25px' }}>
                                                                <MdCancel onClick={this.ClearSearchBox} />
                                                            </div>
                                                        </div>
                                                        :
                                                        null}
                                                </div>
                                                <div className="css-ik6y5r Scrollsearchmenu">
                                                    {this.renderList()}
                                                </div>
                                            </div>

                                        </Collapse>


                                    </div>
                                    <div className="col-lg-3 mediasetmargin">
                                        <p >Choose author(s)</p>
                                        <MultiSelectCheckbox searchauthor={this.state.searchAuthor} AuthorName={this.state.authorName} SearchCallback={this.updateAuthorCount.bind(this)} ref={this.child} />
                                    </div>
                                    <div className="col-lg-3 mediasetmargin">
                                        <p >Choose publication date</p>
                                        {this.RenderPublicationDateList()}
                                        <li>
                                            <div className="row">
                                                {this.state.ShowDatePicker ?
                                                    <span className="Searchlabel"> Start Date :
                                                        <DatePicker
                                                            selected={this.state.StartDate}
                                                            onChange={this.handleStartDateChange}
                                                        />
                                                    </span>
                                                    : null}
                                            </div>
                                            <div className="row">
                                                {this.state.ShowDatePicker ?
                                                    <span className="Searchlabel"> End Date :
                                                        <DatePicker
                                                            selected={this.state.EndDate}
                                                            onChange={this.handleEndDateChange}
                                                        />
                                                    </span>
                                                    : null}
                                            </div>
                                        </li>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <li className="float-right"><a className="LinkClass" onClick={this.unCheckIt} style={{
                                            cursor: 'pointer'
                                        }}>Clear all</a></li> <br></br>
                                    </div>
                                </div>
                            </div>
                        </ul>

                    </Collapse>


                    {/* <input type="text" className="form-control heightset" placeholder="Search all content" /> */}

                    <InputGroup>

                        <div className="SearchPrepend" style={document.location.pathname == "/" ? SearchShadow : null}>
                            <div className="btn-group Responsivewidth" style={{ display: 'inline-block' }}>
                                {this.state.Showpublication ?

                                    this.state.getResult.map(item => {
                                        return (<div className="btn-group" style={{ display: "inline-flex", height: '45px', borderRadius: '4px', margin: '1px' }}>

                                            <div style={{
                                                border: "1px solid #fff", padding: "12px", background: "#007AC3", borderRadius: "10px 0 0 10px", color: "#fff"
                                            }}>
                                                {this.stingBreakLine(item, 40, '')}</div>
                                            <button aria-label="Close" type="button" style={{ padding: '0px 9px', borderRadius: '0px 10px 10px 0px', background: "#007AC3", color: '#fff', border: '1px solid #fff', borderLeft: '0' }}
                                                onClick={this.RemoveButton.bind(this, item)}>
                                                <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>

                                        </div>)
                                    })
                                    :
                                    null}

                                

                                {this.state.Subscriptionchecked ?
                                    <div className="btn-group" style={{ display: "inline-flex", height: '45px', borderRadius: '4px', margin: '1px' }}>

                                        <div style={{
                                            border: "1px solid #fff", padding: "12px", background: "#007AC3", borderRadius: "10px 0 0 10px", color: "#fff"
                                        }}>
                                            Subscribed publications</div>
                                        <button aria-label="Close" type="button" style={{ padding: '0px 9px', borderRadius: '0px 10px 10px 0px', background: "#007AC3", color: '#fff', border: '1px solid #fff', borderLeft: '0' }}
                                            onClick={() => this.setState({
                                                Subscriptionchecked: !this.state.Subscriptionchecked,
                                                checked: false
                                            })}>
                                            <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>

                                    </div>

                                    :
                                    null
                                }

                                {this.state.showwordstitle ?
                                    <div className="btn-group" style={{ display: "inline-flex", height: '45px', borderRadius: '4px', margin: '1px' }}>

                                        <div style={{
                                            border: "1px solid #fff", padding: "12px", background: "#007AC3", borderRadius: "10px 0 0 10px", color: "#fff"
                                        }}>
                                            Words in title</div>
                                        <button aria-label="Close" type="button" style={{ padding: '0px 9px', borderRadius: '0px 10px 10px 0px', background: "#007AC3", color: '#fff', border: '1px solid #fff', borderLeft: '0' }}
                                            onClick={() => this.setState({
                                                showwordstitle: !this.state.showwordstitle,
                                                checked: false
                                            })}>
                                            <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>

                                    </div>

                                    :
                                    null
                                }

                                {this.state.showAuthor ?
                                    <div className="btn-group" style={{ display: "inline-flex", height: '45px', borderRadius: '4px', margin: '1px' }}>

                                        <div style={{
                                            border: "1px solid #fff", padding: "12px", background: "#007AC3", borderRadius: "10px 0 0 10px", color: "#fff"
                                        }}>
                                            Author ({Authorcount})</div>
                                        <button aria-label="Close" type="button" style={{ padding: '0px 9px', borderRadius: '0px 10px 10px 0px', background: "#007AC3", color: '#fff', border: '1px solid #fff', borderLeft: '0' }}
                                            onClick={this.HideAuthor}>
                                            <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>

                                    </div>

                                    :
                                    null
                                }

                                {this.state.ShowBlueChip ?

                                    <div className="btn-group" style={{ display: "inline-flex", height: '45px', borderRadius: '4px', margin: '1px' }}>

                                        <div style={{
                                            border: "1px solid #fff", padding: "12px", background: "#007AC3", borderRadius: "10px 0 0 10px", color: "#fff"
                                        }}>
                                            {this.state.ContentItem !== undefined ? this.state.ContentItem.length > 40 ? this.stingBreakLine(this.state.ContentItem, 40, '') : this.state.ContentItem : ""}</div>
                                        <button aria-label="Close" type="button" style={{ padding: '0px 9px', borderRadius: '0px 10px 10px 0px', background: "#007AC3", color: '#fff', border: '1px solid #fff', borderLeft: '0' }}
                                            onClick={this.RemoveBlueChip}>
                                            <span aria-hidden="true" style={{ fontSize: '21px' }}><MdClose /></span></button>

                                    </div>


                                    :
                                    null
                                }

                                {this.state.showSearchText ?

                                    this.searchTextPill()

                                    :
                                    null
                                }

                                {this.state.showSearchText || this.state.ShowBlueChip || this.state.Showpublication || this.state.showAuthor ?
                                    <div className="btn-group">
                                        <FormControl id="Searchid" aria-describedby="basic-addon3"
                                            style={otherstyle}
                                            autoComplete="off"
                                            placeholder={this.state.PlaceHolder} title="Enter your search term" className="SearchcustomForm" ref={this.searchBar} onBlur={this.SearchTextLostFocus} onKeyDown={this._handleKeyDown} onChange={this.gettext}
                                            value={this.state.getInput} />
                                    </div>
                                    :
                                    <FormControl id="Searchid" aria-describedby="basic-addon3"
                                        style={otherstyle}
                                        autoComplete="off"
                                        placeholder={this.state.PlaceHolder} title="Enter your search term" className="SearchcustomForm" ref={this.searchBar} onBlur={this.SearchTextLostFocus} onKeyDown={this._handleKeyDown} onChange={this.gettext}
                                        value={this.state.getInput} />
                                }

                            </div>
                        </div>
                        {document.location.pathname == "/" ?
                            <span style={SearchShadow} className="HeightForSearch">
                                <Link to={{ pathname: "/SearchContent", state: { GetInputText: this.state.getInput } }} className="RSSCard" title="Search content button">
                                    <span class="sr-only sr-only-focusable">Search content button</span><MdSearch className="SearchIcon" onClick={this.updateCustomParent} />
                                </Link>
                            </span>
                            :
                            <span>
                                <Link to={{ pathname: "/SearchContent", state: { GetInputText: this.state.getInput } }} className="RSSCard" title="Search content button">
                                    <span class="sr-only sr-only-focusable">Search content button</span><MdSearch className="SearchIcon" onClick={this.updateCustomParent} />
                                </Link>
                            </span>
                        }
                        <span className="ImgSearchQue RSSCard" onClick={this.handleClick} style={{ cursor: 'pointer' }}>
                            <IoMdHelp className="SearchHelpIcon" id="PopoverClick" />
                        </span>

                    </InputGroup>
                    <UncontrolledPopover trigger="click" placement="top" target="PopoverClick" isOpen={this.state.show}>
                        <PopoverHeader></PopoverHeader>
                        <PopoverBody>
                            <div className="popover-header h3">
                                <div className="row">
                                    <div className="col-lg-10">
                                        <h5>Search query help</h5>
                                    </div>
                                    <div className="col-lg-2">
                                        <button type="button" className="close" data-dismiss="popover" aria-hidden="true"
                                            onClick={() => this.setState({ show: false })}>
                                            &times;</button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <hr></hr>
                                    <br></br>
                                    <div className="row">
                                        <div className="col-lg-2" style={{ paddingLeft: '5%' }}>AND</div>
                                        <div className="col-lg-9"><p>
                                            Both terms must appear at least once. Multi-word search terms are treated as AND searches by default (so no need to add AND, although the search will still work if you do add it).
                                             <br></br> Example: green AND blue
                                            </p></div>
                                    </div>
                                    <hr></hr>
                                    <br></br>
                                    <div className="row">
                                        <div className="col-lg-2" style={{ paddingLeft: '5%' }}>NOT</div>
                                        <div className="col-lg-9"><p>
                                            Must contain the first term but not the second.
                                                 <br></br> Example: green NOT blue
                                            </p></div>
                                    </div>
                                    <hr></hr>
                                    <br></br>
                                    <div className="row">
                                        <div className="col-lg-2" style={{ paddingLeft: '5%' }}>OR</div>
                                        <div className="col-lg-9"><p>
                                            At least one of the terms must be present
                                                <br></br> Example: green OR blue
                                            </p></div>
                                    </div>

                                </div>
                                <div className="col-lg-6">
                                    <hr></hr>
                                    <br></br>
                                    <div className="row">

                                        <div className="col-lg-2" style={{ paddingLeft: '5%' }}>*</div>
                                        <div className="col-lg-9"><p>

                                            Universal character. Use *  to replace a number or character.
                                                    <br></br> Example: test*

                                            </p></div>
                                    </div>
                                    <hr></hr>
                                    <br></br>
                                    <div className="row">
                                        <div className="col-lg-2">“ “</div>
                                        <div className="col-lg-9"><p>
                                            Exact match phrases. Exact search phrases need to be enclosed in quotation marks. If quotation marks are not used, the default search is AND.
                                                <br></br> Example: "force majeure"
                                            </p></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <p>
                                        Note: Boolean operators (e.g. AND) must be written in capital letters and must include a space before and after the Boolean operator (so " AND ").
                                        </p>
                                </div>
                            </div>
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>
                {!this.state.showText ?
                    <div style={{ paddingLeft: '1%', paddingTop: '1%' }}>
                        <Link to="/CitationSearch" className="LinkClass">Citation search</Link>
                    </div>
                    :
                    null}

            </div >
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Home/Search.jsx